module.exports = __webpack_public_path__ + "img/DNARepair-BRCA_10X_DCIS.eaa437f9.png";